<template>
  <div>
    <div
      class="medication-detail"
      v-if="MedicationDetail && Object.keys(MedicationDetail).length"
    >
      <div class="medication-detail__top">
        <div class="content">
          <div class="medication-detail__top-container">
            <div class="medication-detail__text">
              <div class="medication-detail__name-container">
                <div
                  class="medication-detail__name"
                  v-html="MedicationDetail.name"
                ></div>
                <div
                  class="medication-detail__ingredient"
                  v-html="MedicationDetail.substance"
                ></div>
              </div>
              <div class="medication-detail__icons">
                <div
                  class="medication-detail__icon"
                  :class="{ 'medication-detail__icon_disable': !cat.active }"
                  v-for="cat in filteredIcons"
                  :key="cat.id"
                >
                  <router-link
                    v-if="cat.active"
                    :to="{ name: 'NosologyDetail', params: { slug: cat.slug } }"
                    ><img :src="$root.host + cat.icon"
                  /></router-link>
                  <div v-else><img :src="$root.host + cat.icon" /></div>
                </div>
              </div>
            </div>
            <div class="medication-detail__image-container">
              <img
                class="medication-detail__image"
                :src="MedicationDetail.image"
              />
            </div>
          </div>
        </div>
      </div>
      <Breadcrumbs
        :pages="[
          { name: 'Препараты АЗ', link: { name: 'Medications' } },
          { name: MedicationDetail.name },
        ]"
      />
      <div class="content">
        <div class="medication-detail__row">
          <div class="medication-detail__list">
            <div class="material__tags">
              <div
                class="material__tag"
                v-for="tag in MedicationDetail.nosology"
                :key="tag.id"
                v-html="tag.title"
              ></div>
              <Favorite
                class="large ml-auto ml-xs-0"
                :watchLater="MedicationDetail.watch_later"
                :favorite="MedicationDetail.favorite"
                @watchLater="
                  watchLater(
                    MedicationDetail.watch_later ? 'DELETE' : 'POST',
                    MedicationDetail.slug,
                    null,
                    true
                  )
                "
                @favorite="
                  favorite(
                    MedicationDetail.favorite ? 'DELETE' : 'POST',
                    MedicationDetail.slug,
                    null,
                    true
                  )
                "
              />
            </div>
            <div class="materials">
              <FileBlock
                v-for="material in MedicationDetail.files"
                :key="material.id"
                :material="material"
                :kind="material.file ? 'file' : 'link'"
                @linkClick="linkClick(material.name, material.id)"
              />
            </div>
            <div v-if="!MedicationDetail.hide_content">
              <InfoDrop v-for="(item, ind) in blocks" :key="ind" :item="item" />
            </div>
          </div>
          <RightAside
            v-if="!NewRecommendations || !NewRecommendations.length"
            :items="asideItems"
            @calendarClick="calendarClick"
          />
          <RecMaterials :parent="{name: MedicationDetail.name, id: MedicationDetail.id, type: 'Препарат (старый шаблон)'}" v-else />
        </div>
      </div>
    </div>
    <div v-else-if="MedicationDetail === 404">
      <Choch class="inPage" />
    </div>
    <div v-else-if="MedicationDetail === false"><Error class="inPage" /></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Breadcrumbs from "../components/pageComponents/Breadcrumbs.vue";
import InfoDrop from "../components/pageComponents/InfoDrop.vue";
import FileBlock from "../components/pageComponents/FileBlock.vue";
import RightAside from "../components/pageComponents/RightAside.vue";
import Choch from "@/views/404.vue";
import Error from "@/views/Error.vue";
import Favorite from "@/components/pageComponents/Favorite.vue";
import RecMaterials from "@/components/pageComponents/RecMaterials.vue";
import pageVisit from "@/mixins/pageVisit";
export default {
  metaInfo() {
    if (this.MedicationDetail.name) {
      return { title: this.MedicationDetail.name.replace(/<[^>]*>?/gm, "") };
    } else {
      return { title: this.MedicationDetail.name };
    }
  },
  name: "MedicationDetail",
  mixins: [pageVisit],
  components: {
    Breadcrumbs,
    RightAside,
    InfoDrop,
    FileBlock,
    Choch,
    Error,
    Favorite,
    RecMaterials,
  },
  data: () => ({}),
  computed: {
    ...mapGetters(["MedicationDetail", "NewRecommendations"]),
    filteredIcons() {
      return this.MedicationDetail.nosology.filter((el) => el.icon);
    },
    asideItems() {
      return [
        {
          title: "Календарь мероприятий",
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-2.jpg`,
          image_desktop: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-2_small.jpg`,
          event: "calendarClick",
          to: {
            name: "Events",
            query: {
              therapeutic_areas: this.MedicationDetail.nosology
                .map((el) => el.slug)
                .join(","),
            },
          },
        },
      ];
    },
    blocks() {
      let obj = [];
      let fields = [
        {
          title: "О препарате",
          slug: "about",
        },
        {
          title: "Фармакологические свойства",
          slug: "properties",
        },
        {
          title: "Показание к применению",
          slug: "indication",
        },
        {
          title: "Противопоказания",
          slug: "contraindications",
        },
        {
          title: "Способ применения и дозы",
          slug: "application",
        },
        {
          title: "Побочное действие",
          slug: "side_effects",
        },
        {
          title: "Передозировка",
          slug: "overdose",
        },
        {
          title: "Взаимодействие с другими лекарственными средствами",
          slug: "interaction",
        },
        {
          title: "Особые указания",
          slug: "special",
        },
        {
          title:
            "Влияние на способность к управлению транспортными средствами и механизмами",
          slug: "drive",
        },
        {
          title: "Форма выпуска",
          slug: "release_form",
        },
      ];
      for (let field of fields) {
        if (this.MedicationDetail[field.slug]) {
          obj.push({
            title: field.title,
            content: this.MedicationDetail[field.slug],
          });
        }
      }
      return obj;
    },
  },
  methods: {
    ...mapActions([
      "fetchMedicationDetail",
      "fetchMedicationFavorite",
      "fetchMedicationWatchLater",
      "fetchMedicationHistory",
      "fetchNewRecommendations",
    ]),
    async watchLater(method, slug, filter, favoritePage) {
      await this.fetchMedicationWatchLater({
        method: method,
        slug: slug,
        filter: filter,
        favoritePage: favoritePage,
      });
      await this.fetchMedicationDetail({
        slug: this.$route.params.slug,
        access: this.$route.query.access || null,
      });
    },
    async favorite(method, slug, filter, favoritePage) {
      await this.fetchMedicationFavorite({
        method: method,
        slug: slug,
        filter: filter,
        favoritePage: favoritePage,
      });
      await this.fetchMedicationDetail({
        slug: this.$route.params.slug,
        access: this.$route.query.access || null,
      });
    },
    linkClick(title,id) {
      const vm = this;
       this.$axios(`/api/analytics/send/`, {
        method: "POST",
        data: {
          brand_name: this.MedicationDetail.brands.map((el) => el.title).join(", "),
          brand_id: this.MedicationDetail.brands.map((el) => el.brand_id).join(", "),
          content_date: "",
          content_id: id,
          content_name: title.replace(/<[^>]*>?/gm, ""),
          content_type: "инструкция",
          nosology_name: this.MedicationDetail.disease
            .map((el) => el.name)
            .join(", "),
          content_parameter: "",
          event_type: "download",
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: this.MedicationDetail.name.replace(/<[^>]*>?/gm, ""),
          page_type: "Страница препарата (старый шаблон)",
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        },
      })
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "instruction download", {
          "instruction download": {
            "medications page name": title,
            ...this.$root.ymFields,
          },
        });
      }
    },
    calendarClick(item) {
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "medication page events click", {
          "medication page events click": {
            "medications page name": vm.MedicationDetail.name,
            ...this.$root.ymFields,
          },
        });
      }
      vm.$router.push(item.to).catch(() => {});
    },
    pageVisit(time) {
      this.$axios(`/api/analytics/send/`, {
        method: "POST",
        data: {
          brand_name: this.MedicationDetail.brands.map((el) => el.title).join(", "),
          brand_id: this.MedicationDetail.brands.map((el) => el.brand_id).join(", "),
          content_date: "",
          content_id: this.MedicationDetail.id,
          content_name: this.MedicationDetail.name.replace(/<[^>]*>?/gm, ""),
          content_type: "препарат",
          nosology_name: this.MedicationDetail.disease
            .map((el) => el.name)
            .join(", "),
          content_parameter: "",
          event_type: "visit",
          event_duration: time,
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: this.MedicationDetail.name.replace(/<[^>]*>?/gm, ""),
          page_type: "Страница препарата (старый шаблон)",
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        },
      })
    }
  },
  created() {
    this.fetchNewRecommendations({
      url: this.$route.path,
      without_rec_cards: "false",
    });
  },
  async mounted() {
    if (!this.$route.query.access) {
      await this.fetchMedicationHistory(this.$route.params.slug);
    }
    
  },
  watch: {
    MedicationDetail() {
      localStorage.setItem("medicationBlock", this.MedicationDetail.slug);
    },
  },
};
</script>

<style lang="scss" scoped>
.materials {
  margin-bottom: 40px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media screen and (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
  }
}

.medication-detail {
  &__top {
    height: 400px;
    padding: 32px 0;
    background-color: #ebefee;

    @media screen and (max-width: 1220px) {
      height: auto;
    }
  }

  &__top-container {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    @media screen and (max-width: 1220px) {
      flex-direction: column;
      align-items: stretch;
    }
  }

  & .content {
    height: 100%;
  }

  &__text {
    padding: 32px 0;
    height: 100%;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 1220px) {
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }

    @media screen and (max-width: 767px) {
      flex-direction: column;
      align-items: stretch;
    }
  }

  &__image-container {
    width: 588px;
    height: 322px;
    margin-left: auto;

    @media screen and (max-width: 1220px) {
      margin-left: 0;
      height: 262px;
      width: 100%;
      margin-top: 40px;
    }
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }

  &__icons {
    margin-top: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    @media screen and (max-width: 1220px) {
      margin-top: 0;
      margin-left: auto;
    }

    @media screen and (max-width: 767px) {
      margin-left: 0;
      margin-top: 16px;
    }
  }

  &__icon {
    margin-right: 8px;
    transition: 0.3s;

    & img {
      width: 64px;
      height: 64px;
      object-fit: contain;
      object-position: center;
      @media screen and (max-width: 767px) {
        width: 40px;
        height: 40px;
      }
    }

    &:last-child {
      margin-right: 0;
    }

    &_disable {
      pointer-events: none;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  &__name {
    margin-bottom: 8px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    line-height: 48px;
    color: #830051;
  }

  &__ingredient {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 23px;
    line-height: 28px;
    display: flex;
    align-items: flex-end;
    color: #656969;
  }

  &__row {
    margin-top: 64px;
    display: grid;
    grid-template-columns: 1fr 280px;
    column-gap: 136px;

    @media screen and (max-width: 1220px) {
      grid-template-columns: 100%;
      row-gap: 40px;
    }
  }
}

.material {
  &__tags {
    margin-bottom: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @media screen and (max-width: 767px) {
      flex-wrap: wrap;
    }
  }

  &__tag {
    padding-left: 10px;
    position: relative;
    margin-right: 8px;
    display: inline-flex;
    align-items: center;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #3c4242;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: break-spaces;

    &::before {
      position: absolute;
      top: 10px;
      left: 0;
      transform: translateY(-50%);
      width: 2px;
      height: 2px;
      background-color: #3c4242;
      border-radius: 50%;
      display: block;
      content: "";
    }

    &:last-child {
      margin-right: 0;
    }

    &_new {
      position: absolute;
      top: 8px;
      left: 8px;
      z-index: 4;
      display: inline-block;
      padding: 4px 8px;
      background: rgba(255, 255, 255, 0.8);
      border: 1px solid #d8dada;
      border-radius: 4px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 10px;
      line-height: 13px;
      color: #1f1f1f;
    }
  }
}

.favorite {
  @media screen and (max-width: 767px) {
    width: 100%;
  }
}
</style>
